import {CuttingState, toStringDisplay as toCuttingState} from "./types/models/CuttingState.d";
import {ShipmentState, toStringDisplay as toShipmentState} from "./types/models/ShipmentState.d";
import {Session} from "../app/slices/sessionSlice.ts";

export function cuttingStateClosedCheck(dbState: string | undefined): boolean {
    const cuttingState = toCuttingState(dbState)
    return !!(cuttingState && cuttingState !== CuttingState.Closed)
}

export function cuttingStateEditCheck(dbState: string | undefined): boolean {
    const cuttingState = toCuttingState(dbState)
    return !!(cuttingState && cuttingState !== CuttingState.Closed && cuttingState !== CuttingState.Finished)
}

export function cuttingStateCheck(session: Session | null, dbState: string | undefined): boolean {
    const cuttingState = toCuttingState(dbState)
    return !!(session && cuttingState && cuttingState !== CuttingState.Closed && (
        session.hasPermission('', 'applications/timber/entities/Cuttings/upcomming/view') && cuttingState === CuttingState.Upcoming
        || session.hasPermission('', 'applications/timber/entities/Cuttings/inprogress/view') && cuttingState === CuttingState.InProgress
        || session.hasPermission('', 'applications/timber/entities/Cuttings/finished/view') && cuttingState === CuttingState.Finished
        || session.hasPermission('', 'applications/timber/entities/Cuttings/closed/view') && cuttingState === CuttingState.Closed
    ))
}

export function shippingStateEditCheck(dbState: string | undefined): boolean {
    const shipmentState = toShipmentState(dbState)
    return !!(shipmentState && shipmentState !== ShipmentState.Closed && shipmentState !== ShipmentState.Finished && shipmentState !== ShipmentState.Cancelled)
}

export function shippingStateClosedCheck(dbState: string | undefined): boolean {
    const shipmentState = toShipmentState(dbState)
    return !!(shipmentState && shipmentState !== ShipmentState.Closed)
}

export function shippingStateCancelCheck(dbState: string | undefined): boolean {
    const shipmentState = toShipmentState(dbState)
    return !!(shipmentState && shipmentState === ShipmentState.Cancelled)
}

export function shippingStateCheck(session: Session | null, dbState: string | undefined): boolean {
    const shipmentState = toShipmentState(dbState)
    return !!(session && shipmentState && shipmentState !== ShipmentState.Closed && shipmentState !== ShipmentState.Cancelled && (
        session.hasPermission('', 'applications/timber/entities/Shipments/upcomming/view') && shipmentState === ShipmentState.Upcoming
        || session.hasPermission('', 'applications/timber/entities/Shipments/inprogress/view') && shipmentState === ShipmentState.InProgress
        || session.hasPermission('', 'applications/timber/entities/Shipments/finished/view') && shipmentState === ShipmentState.Finished
        || session.hasPermission('', 'applications/timber/entities/Shipments/closed/view') && shipmentState === ShipmentState.Closed
        || session.hasPermission('', 'applications/timber/entities/Shipments/cancelled/view') && shipmentState === ShipmentState.Cancelled
    ))
}
